export default "__VITE_ASSET__CQwByKaa__"